import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponentType(_ctx.type)), _mergeProps(_ctx.$attrs, {
    class: { [_ctx.classNames]: true, 'button--disabled': _ctx.disabled },
    type: _ctx.type === 'button' || _ctx.type === 'submit' ? _ctx.type : null,
    href: _ctx.type === 'a' || _ctx.type === 'inertia-link' ? _ctx.href : null,
    disabled: _ctx.disabled,
    target: _ctx.target
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3
  }, 16, ["class", "type", "href", "disabled", "target"]))
}